import { render, staticRenderFns } from "./AddQue.vue?vue&type=template&id=548c4fcc&scoped=true"
import script from "./AddQue.vue?vue&type=script&lang=js"
export * from "./AddQue.vue?vue&type=script&lang=js"
import style0 from "./AddQue.vue?vue&type=style&index=0&id=548c4fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c4fcc",
  null
  
)

export default component.exports